export default "__VITE_ASSET__78f91bcb__"